<ng-container *ngIf="content$ | async as teaser">
  <fin-disclaimer [disclaimer]="teaser" />
</ng-container>
